import HoldToProceedButton from './HoldToProceedButton'

export default HoldToProceedButton
